export enum FieldValidityType {
  Notify,
  Inline,
}
